import React from 'react';

const SecurityIcon = ({width = 20}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width={width} height={width} >
    <g data-name="Layer 2">
      <path fill="none" d="M0 0h48v48H0z" data-name="invisible box" />
      <g data-name="icons Q2">
        <path
          fill="currentColor"
          d="M24 6.2c5.3 1.5 11.1 3.3 14 4.3v15.7c0 3.4-3.7 9.4-14 15.4-10.3-6.1-14-12-14-15.4V10.5c2.9-1.1 8.7-2.8 14-4.3M24 2S6 7.1 6 8v18.2c0 9.2 13.3 17.3 17 19.5a1.8 1.8 0 0 0 2 0c3.8-2.1 17-10.3 17-19.5V8c0-.9-18-6-18-6Z" />
        <path
          fill="currentColor"
          d="m19.6 29.4-5-4.9a2.1 2.1 0 0 1-.2-2.7 1.9 1.9 0 0 1 3-.2l3.6 3.6 9.6-9.6a2 2 0 0 1 2.8 2.8l-11 11a1.9 1.9 0 0 1-2.8 0Z" />
      </g>
    </g>
  </svg>
);

export default SecurityIcon;